import { GET_GROUPSBYYEAR, GET_GROUPSBYLESSONCOUNT, GET_PARTICIPANTAMOUNTS, GET_TOPLEADERS, GET_TOPLEADERSMORE, GET_FEEOVERVIEW, GET_DEBITORSONEYEAR, GET_DEBITORSTWOYEAR, GET_DEBITORSONEYEARMORE, GET_DEBITORSTWOYEARMORE } from '../actions/types'

export default function statisticsReducer(state = {}, action) {
  switch (action.type) {
    case GET_GROUPSBYYEAR:
      return {...state, groupsbyyear: action.groupsbyyear}
    case GET_GROUPSBYLESSONCOUNT:
      return {...state, groupsbylessoncount: action.groupsbylessoncount}
    case GET_PARTICIPANTAMOUNTS:
      return {...state, participantamounts: action.participantamounts}
    case GET_TOPLEADERS:
      return {...state, topleaders: action.topleaders}
    case GET_TOPLEADERSMORE:
      return {...state, topleaders: state.topleaders.concat(action.topleaders)}
      
    case GET_FEEOVERVIEW:
      return {...state, feeoverview: action.feeoverview}
    case GET_DEBITORSONEYEAR:
      return {...state, debitorsoneyear: action.debitorsoneyear}
    case GET_DEBITORSONEYEARMORE:
      return {...state, debitorsoneyear: state.debitorsoneyear.concat(action.debitorsoneyear)}
    case GET_DEBITORSTWOYEAR:
      return {...state, debitorstwoyear: action.debitorstwoyear}
    case GET_DEBITORSTWOYEARMORE:
      return {...state, debitorstwoyear: state.debitorstwoyear.concat(action.debitorstwoyear)}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/statistics_reducer.js